import ApiClient from "@/api/ApiClient";

const CUSTOMERS_API_PATH = "customers";

interface ElizaStatusData {
  idWg: number | string;
  value: boolean;
}

interface CustomerResponse {
  // Define the structure of customer response data here
  // Add other customer properties as needed
  [key: string]: any;
}

/**
 * Set Eliza status
 * @param workgroupId - The workgroup ID
 * @param value - boolean true enables eliza, false disables it
 * @returns Promise with the response data
 */
export function setElizaStatus(
  workgroupId: number | string,
  value: boolean
): Promise<CustomerResponse> {
  const data: ElizaStatusData = {
    idWg: workgroupId,
    value,
  };

  return ApiClient()
    .put(`${CUSTOMERS_API_PATH}/eliza`, data)
    .then((response) => response.data);
}

/**
 * Get customer by phone number
 * @param wgId - Workgroup ID
 * @param phone - Phone number to search for
 * @returns Promise with customer data
 */
export function getCustomerByPhone(
  wgId: number | string,
  phone: string
): Promise<CustomerResponse> {
  return ApiClient()
    .get(`${CUSTOMERS_API_PATH}/customers2`, {
      params: {
        wgId,
        phone,
      },
    })
    .then((response) => response.data);
}

/**
 * Update partial customer data by ID
 * @param wgId - Workgroup ID
 * @param phoneId - Phone ID of the customer
 * @param data - Partial customer data to update
 * @returns Promise with updated customer data
 */
export function patchCustomerById(
  wgId: number | string,
  phoneId: string,
  data: Partial<CustomerResponse>
): Promise<CustomerResponse> {
  return ApiClient()
    .patch(`${CUSTOMERS_API_PATH}`, data, {
      params: {
        wgId,
        phoneId,
      },
    })
    .then((response) => response.data);
}

/**
 * Update customer by ID
 * @param wgId - Workgroup ID
 * @param phoneId - Phone ID of the customer
 * @param data - Customer data to update
 * @returns Promise with the response data
 */
export async function updateCustomerById(
  wgId: number,
  phoneId: string,
  data: Partial<CustomerResponse>
): Promise<CustomerResponse> {
  const params = {
    wgId,
    phoneId,
  };

  const response = await ApiClient().patch("customers", data, {
    params,
    headers: { "content-type": "application/json" },
  });

  return response.data;
}

export type { CustomerResponse };
